module.exports = __webpack_public_path__ + "static/flc-2b0417ce5d40c29e1111f96edaf861ef.jpg";